import { Nature, Section } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CovidPanel from '../panel/CovidPanel';
import DelaiPaiementPanel from '../panel/DelaiPaiementPanel';
import FctvaPanel from '../panel/FctvaPanel';
import ProjetPanel from '../panel/ProjetPanel';
import BaseProfilEcritureDepense from './Base/BaseProfilEcritureDepense';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import InformationsChorusProPanel from '../panel/InformationsChorusProPanel';
import PeriodeCouvertePanel from '../panel/PeriodeCouvertePanel';
import TravauxEnRegiePanel from '../panel/TravauxEnRegiePanel';

class ProfilEcritureOrdFoncDepense extends BaseProfilEcritureDepense {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.DEPENSE.ORD_FONC;
    this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.DEPENSE.FONCTIONNEMENT;
    this.typePiece = TYPE_PIECE.DEPENSE.ORDINAIRE;
    this.imputation.nature = Nature.REEL;
    this.imputation.section = Section.FONCTIONNEMENT;
    this.modeDeReglement = [
      MODE_REGLEMENT.DEPENSE.NUMERAIRE,
      MODE_REGLEMENT.DEPENSE.CHEQUE,
      MODE_REGLEMENT.DEPENSE.VIREMENT,
      MODE_REGLEMENT.DEPENSE.VIREMENT_GROS_MT,
      MODE_REGLEMENT.DEPENSE.VIREMENT_ETRANGER,
    ];
    this.panels = [
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new DelaiPaiementPanel(true),
      new FctvaPanel(),
      new InformationsChorusProPanel(),
      new PeriodeCouvertePanel(),
      new ProjetPanel(),
      new TravauxEnRegiePanel(),
      // TODO : add "Nomenclature achat" optional panel
    ];
  }
}

export default ProfilEcritureOrdFoncDepense;
